import axios from 'axios';
import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { v4 } from 'uuid';
import "./newUser.css"

export default function NewUser() {
  const [picture, setPicture] = useState('/playground_assets/account.png');
  const [pic, setPic] = useState();
  const [username, setUsername] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handlePictureChange = async(e) => {
    const file = e.target.files[0]
    setPic(file)
    console.log(file.name)
    setPicture(URL.createObjectURL(file));
    }

  const handleFormSubmit = async(e) => {
    e.preventDefault();
    const uuid = v4()
    const formData = new FormData();
    formData.append('Name', username);
    formData.append('Email', location.state.param2);
    formData.append('Password', location.state.param1);
    formData.append('ProfilePicture', pic);
    formData.append('id', uuid);
    toast.success('User created successfully...');
    try{
        navigate(`/messages/${username}`,{state:{userid:uuid,nom:username}});
        axios.post('http://localhost:3009/createusers', formData ,{
          headers: {
            'api-key': process.env.REACT_APP_API_KEY
          }
         })
        
    }catch{
        toast.error('Failed to create user.');
    }
  }

  return (
    <section className='bod'>
      <Toaster/>
      <div className='body container'>
        <img className='profilimg' src={picture} alt="Profile Picture" />
        <div className="custom-file-input">
          <input onChange={(e)=>handlePictureChange(e)} type="file" id="myFileInput" />
          <label htmlFor="myFileInput"></label>
        </div>

        <form className='newu text-center' onSubmit={handleFormSubmit}>
          <label>Username :</label>
          <input size={30} className="inpt" onChange={(e)=>setUsername(e.target.value)} placeholder='Username' type="text" required />
          <button className='btn btn-success' type="submit">Next→</button>
        </form>
      </div>
    </section>
  );
}

